export default __webpack_public_path__ + "static/media/signup.7ffe6677.png";